import { makeStyles  } from '@material-ui/core/styles';
import {
    Button,
    Grid,
    TableContainer,
    Divider,
    Typography,
    Radio 
} from '@material-ui/core';
import moment from 'moment';

import { useSelector } from 'react-redux';
import { useStylesAuth } from '../../../styles/auth/style';
import { DESTINOS_COMPROBANTE } from '../../../utils/constants';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 30,
    },
    align: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    alignDatos: {
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    text:{ 
        width:'100%',
        border: '1px solid #ccc',
        borderRadius: '.3em',
        textAlign: 'center' 
    },
    textObservaciones:{ 
        width:'100%',
        border: '1px solid #ccc',
        borderRadius: '.5em',
        textAlign: 'left',
        padding: '1em',
        wordBreak: 'break-word'
    },
  }));

const centerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const FormatoImpresionComprobante = ({comprobante, handleClose, handlePrintRow, componentRef, modal, ospeDirecto}) => {
    const classes = useStyles();
    const classesAuth = useStylesAuth("light");

    const { usuarioLiquidaciones } = useSelector(state => state.mesaEntrada);

    const nroSucursal = comprobante?.nroSucursal ? comprobante?.nroSucursal.toString().padStart((5), '0') : "00000";
    const nroFactura = comprobante?.nroFactura ? comprobante?.nroFactura.toString().padStart((8), '0') : "00000000";
    
    return (
        <>
            <TableContainer className={classes.form}>
                <Grid container spacing={2} ref={componentRef}> 
                    <Grid item xs={12} className={classes.logo}>
                        <Grid 
                            container 
                            justify='flex-end'
                        >
                            <Grid 
                                item 
                                xs={6} 
                                className={classesAuth.imageInherit} 
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginTop: '1em'}}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Fecha de Impresion: {moment().format("DD/MM/YYYY")}</Typography> 
                            </Grid>
                            <Grid item xs={6} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Recepción Nro: {comprobante?.idExpediente}</Typography> 
                            </Grid>
                            <Grid item xs={6} className={classes.align}>
                                <Typography style={{fontSize: '1.5em'}} color='primary'>Recepción Nro Sistema Viejo: {comprobante?.idExpedientes}</Typography> 
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography style={{fontSize: '1.3em'}}>
                                    {comprobante?.razonSocial || comprobante?.nombreFantasia} - {comprobante?.idEfectorFacturacion}
                                </Typography> 
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography  style={{fontSize: '1.3em'}}>CUIT: {comprobante?.cuitPrestador}</Typography> 
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography  style={{fontSize: '1.3em'}}>Tipo Contrato: {comprobante?.descripcionTipoEfector}
                                </Typography> 
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginBottom: '2em'}}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'center'}}>
                        <Grid container spacing={2} justify='space-evenly' alignItems='flex-end'>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Fecha de Recepción:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {moment(comprobante?.fechaRecepcion).format("DD/MM/YYYY")}
                                </Typography> 
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Fecha de Comprobante:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {moment(comprobante?.fechaInicioVigencia).format("DD/MM/YYYY")}
                                </Typography> 
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Fecha de Vencimiento:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {moment(comprobante?.fechaFinVigencia).format("DD/MM/YYYY")}
                                </Typography>  
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '1em'}}>
                                <Divider variant="middle" />
                            </Grid>
                            <Grid item xs={5} className={classes.alignDatos}>
                                <Typography>Tipo Comprobante:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {comprobante?.descripcionTipoComprobante}
                                </Typography> 
                            </Grid>
                            <Grid item xs={5} className={classes.alignDatos}>
                                <Typography>Procedencia:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {comprobante?.descripcionProcedencia}    
                                </Typography> 
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '1em'}}>
                                <Divider variant="middle" />
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Tipo Factura:</Typography> 
                                <Typography variant='overline' className={classes.text}>
                                    {comprobante?.descripcionTipoFactura ? comprobante?.descripcionTipoFactura : "-"}    
                                </Typography> 
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography style={{whiteSpace: 'nowrap'}}>Nro de Sucursal:</Typography> 
                                <Typography variant='overline' className={classes.text}>{nroSucursal}</Typography> 
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Nro de Factura:</Typography> 
                                <Typography variant='overline' className={classes.text}>{nroFactura}</Typography> 
                            </Grid>
                            <Grid item xs={3} className={classes.alignDatos}>
                                <Typography>Total Comprobante:</Typography> 
                                <Typography variant='overline' className={classes.text}>$ {comprobante?.totalComprobante}</Typography> 
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '1em'}}>
                                <Divider variant="middle" />
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Usuario Ingreso:</Typography> 
                                <Typography variant='overline' className={classes.text}>{ospeDirecto ? (comprobante.razonSocial || comprobante.nombreFantasia) : comprobante?.nombreUsuarioCarga}</Typography> 
                            </Grid>
                            {comprobante.idDestino === DESTINOS_COMPROBANTE.LIQUIDACIONES && (
                                <Grid item xs={4} className={classes.alignDatos}>
                                    <Typography>Usuario Liquidaciones:</Typography> 
                                    <Typography variant='overline' className={classes.text}>{!usuarioLiquidaciones ? "No posee" : usuarioLiquidaciones}</Typography> 
                                </Grid>
                            )}
                            <Grid item xs={12} style={{...centerStyle, gap: "2em"}}>
                                <div style={centerStyle}>
                                    <Radio
                                        checked={comprobante.ambulatoria}
                                        color="primary"
                                        name="radio-button-demo"
                                        disabled
                                    />
                                    <Typography>Ambulatoria</Typography>
                                </div>
                                <div style={centerStyle}>
                                    <Radio
                                        checked={comprobante.internacion}
                                        color="primary"
                                        name="radio-button-demo"
                                        disabled
                                    />
                                    <Typography>Con Internación</Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '2em'}}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12} className={classes.alignDatos}>
                                <Typography>Observaciones:</Typography> 
                                <Typography variant='overline' className={classes.textObservaciones}>
                                    {comprobante?.observacionesComprobante === '' ? 'No hay observaciones.' : comprobante?.observacionesComprobante}
                                </Typography> 
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {modal &&
                    (<Grid item xs={12} style={{ display:'flex', justifyContent:'flex-end', alignItems:'center', marginTop: '1em' }}>
                        <Button style={{marginRight:5}} onClick={handleClose} variant='contained' color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handlePrintRow} variant='contained' color="primary" autoFocus>
                            Imprimir
                        </Button>
                    </Grid>)
                }
            </TableContainer>
        </>
    );
}